import "./header.scss";

import instaIcon from "../../assets/images/icons/insta-green.svg";
import telIcon from "../../assets/images/icons/telegram-green.svg";
import locationIcon from "../../assets/images/icons/location-green.svg";
import whiteInstaIcon from "../../assets/images/icons/insta.svg";
import whiteTelIcon from "../../assets/images/icons/telegram.svg";
import whiteLocationIcon from "../../assets/images/icons/location.svg";
import logo from "../../assets/icons/logo.png";
import whiteLogo from "../../assets/icons/logo-white.png";

import React, { useState, Fragment } from "react";

import { NavLink } from "react-router-dom";
import { useSelector } from "react-redux";
import Sidebar from "../Sidebar";
import Toggle from "../Toggle";

const Header = ({ configs }) => {
  // states
  const [showSidebar, setShowSidebar] = useState(false);

  // store
  const darkThemeFromStore = useSelector((state) => state.Reducer.darkTheme);

  // handlers
  const scrollToFooter = () => {
    const footerSection = document.getElementById("footer-sec");
    if (footerSection) {
      footerSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <Fragment>
      <header className={`header ${darkThemeFromStore ? "dark-back" : ""}`}>
        <div className="logo-nav">
          <Sidebar showSidebar={showSidebar} setShowSidebar={setShowSidebar} />

          <nav className="nav page-nav">
            <ul>
              <li className="forms menu-item">
                {" "}
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "isActive menu-link" : "menu-link"
                  }
                >
                  <span>خانه</span>
                </NavLink>
              </li>
              <li className="forms menu-item">
                {" "}
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "isActive menu-link" : "menu-link"
                  }
                >
                  <span>فرم ها</span>
                </NavLink>
              </li>
              <li className="contact-us menu-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "isActive menu-link" : "menu-link"
                  }
                  onClick={scrollToFooter}
                >
                  <span>تماس با ما</span>
                </NavLink>
              </li>
              <li className="about-us menu-item">
                <NavLink
                  to="/"
                  className={({ isActive }) =>
                    isActive ? "isActive menu-link" : "menu-link"
                  }
                >
                  <span>درباره ما</span>
                </NavLink>
              </li>
            </ul>
          </nav>
          <NavLink to="/">
            <div className="logo">
              <img
                src={darkThemeFromStore ? whiteLogo : logo}
                alt="صراافی مجتهدی"
              />
            </div>
          </NavLink>
        </div>
        <nav className="nav config-nav">
          <ul>
            <li
              className={`br-left theme-li ${darkThemeFromStore ? "white-br-left" : ""}`}
            >
              <div className="theme">
                {darkThemeFromStore ? (
                  <div>حالت روشن</div>
                ) : (
                  <div>حالت تیره</div>
                )}
                <div
                  className={`toggle ${darkThemeFromStore ? "white-br" : ""}`}
                >
                  <Toggle />
                </div>
              </div>
            </li>
            <li className="social">
              <a href={`https://instagram.com/${configs?.instagram}`}>
                <img
                  alt="social"
                  src={darkThemeFromStore ? whiteInstaIcon : instaIcon}
                />
              </a>
              <a href={`https://t.me/${configs?.telegram}`}>
                <img
                  alt="social"
                  src={darkThemeFromStore ? whiteTelIcon : telIcon}
                />
              </a>
              <a href="https://maps.app.goo.gl/d3fPk9QEK5WXFyYLA">
                <img
                  alt="social"
                  src={darkThemeFromStore ? whiteLocationIcon : locationIcon}
                />
              </a>
            </li>
          </ul>
        </nav>
      </header>
    </Fragment>
  );
};

export default Header;
